import { ILoginUser } from '../../common/interfaces/dtos/ILoginUser';
import { shiftStart } from './service/shift-start-service';
import { login } from './sign-in';
import { signOff } from './sign-off';

export const posLogin = async (user: ILoginUser, useTrainingModeAPIs: boolean): Promise<void> => {
  await login(user, useTrainingModeAPIs);
  if (useTrainingModeAPIs) {
    await notifyCashierShiftStart();
  }
};

const notifyCashierShiftStart = async (): Promise<void> => {
  await shiftStart('OnSignIn').catch((err): void => {
    if (err.code === 'AccountNotFound') {
      signOff();
    }
    throw err;
  });
};
